module.exports = __webpack_public_path__ + "static/media/ImageSelectTickDisabled.ca0e924c.svg";